<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rRQr4B/tc-custom/9781626814103.jpg?1705605503934" alt="This image is the cover for the book Great Society"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Great Society
      </h1>
      <p class="bookDescription body article font2">
        <b>A stirring profile of our 36th president, Lyndon B. Johnson, who presided over one of the most tumultuous eras in our country’s history.</b><br/>  <br/> Lyndon B. Johnson’s unprecedented and ambitious domestic vision in the 1960s changed the nation. It unraveled and restitched the very fabric of the American life. It knocked down racial barriers, provided health care for the elderly and food for the poor, sustained orchestras and museums in cities across the country, and put seat belts and padded dashboards in every automobile. But it also carved the deep philosophical divide that has come to define the nation’s harsh politics.<br/>  <br/> Half a century later, the policies of Lyndon B. Johnson continue to define politics and power in America. <i>The Great Society: 50 Years Later</i> is a series from the<i> Washington Post</i> that examines the legacy—and limits—of Johnson’s deeply humanistic, and profoundly revolutionary social agenda.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        The Washington Post
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?375386f8